<template>
  <header>
    <component v-bind:is="headTag" class="logo">
      <router-link to='/'>Global Header</router-link>
    </component>
  </header>
</template>

<script>

export default {
  name: 'GlobalHeader',
  components: {
  },
  computed: {
    headTag() {
      return this.$route.name === 'Home' ? 'h1' : 'p';
    },
  },
  created() {
  },
  methods: {
  },
};
</script>

<style lang="scss">
</style>
